<template>
  <IModal :with-action-button="!!textOk" :with-cancel-button="false" :text-ok="textOk" @ok="onOK" @close="onClose">
    <div :class="$style.content">
      <svg width="85" height="85" viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg" :class="$style.icon">
        <path
          d="M84.915 39.7543V39.7505C84.4676 32.7473 82.2886 26.1943 78.8186 20.5023C75.2155 14.5739 70.2047 9.59521 64.2494 6.03169C58.6151 2.65045 52.1517 0.528605 45.2509 0.0875013C44.3282 0.0285658 43.4093 -0.000652995 42.4962 1.10679e-05C19.0204 0.00133919 0.00133895 19.0309 1.08273e-05 42.5045C-0.000653235 43.4176 0.0292296 44.3378 0.0894932 45.2665V45.2627C0.534415 52.2347 2.6971 58.7606 6.14192 64.4355C9.69184 70.3018 14.619 75.2414 20.4764 78.8061C26.1722 82.2835 32.731 84.4663 39.7407 84.9138C40.6667 84.9728 41.5849 85 42.4962 85C65.9698 84.9987 84.998 65.9783 84.9993 42.5038C84.9993 41.5934 84.9721 40.6765 84.915 39.7543ZM4.9994 42.5045C5.00123 32.1395 9.19263 22.7798 15.981 15.9842C22.7734 9.19379 32.132 5.00107 42.4962 4.99924C43.3022 4.99924 44.1155 5.0258 44.9345 5.0776C63.573 6.24037 78.7621 21.4283 79.9256 40.0661L79.9242 40.0622C79.9755 40.8807 80.0003 41.695 80.0003 42.5037C79.9983 52.8673 75.8064 62.2253 69.0154 69.0182C62.2203 75.8072 52.8599 79.9986 42.4964 80.0004C41.6877 79.9999 40.8737 79.9752 40.0561 79.9239C21.4257 78.7615 6.24253 63.5775 5.07909 44.9467V44.9429C5.02597 44.1226 5.00057 43.3107 4.9994 42.5045Z"
          fill="#C6937A"
        />
        <path d="M65.5776 32.4846L65.5828 32.4802L65.6015 32.4606L59.3456 26.2053L38.9542 46.587L26.8947 34.517L20.6289 40.7731L38.9542 59.0984L65.5776 32.4846Z" fill="#C6937A" />
      </svg>
      <h3 :class="$style.title">会員登録が完了しました</h3>
      <p v-if="!isSeller && isPreSeller" :class="$style.lead">ショップ開設にお進みください。</p>
      <p v-else :class="$style.lead">
        メールアドレスの認証と会員登録が完了しました。iichiにご登録いただきありがとうございます。<br />
        引き続き、iichiをお楽しみください。
      </p>
    </div>
  </IModal>
</template>

<script setup lang="ts">
import { Credential } from '@iichi/core-member';
import { computed } from 'vue';
import { useMQ } from '@/js/lib/helper/media-query';
import { NativeView, urlForDeepLink } from '@/js/lib/helper/yappli';
import { useCartStore } from '@/js/lib/store/cart';
import { useUserStore } from '@/js/lib/store/user';
import IModal from '@/js/components/molecules/IModal.vue';

const props = defineProps<{
  fromNative?: boolean;
}>();
const emit = defineEmits<{
  (e: 'close'): void;
}>();
const userStore = useUserStore();
const cartStore = useCartStore();
const isPreSeller = userStore.hasCredential(Credential.PRE_SELLER);
const isSeller = userStore.hasCredential(Credential.SELLER);
const { isSp } = useMQ();
const itemInCart = computed(() => cartStore.itemCount > 0);
const textOk = computed(() => {
  let text = '';
  if (props.fromNative && isSp.value) {
    text = 'アプリに戻る';
  } else if (isSeller) {
    text = 'マイページ';
  } else if (isPreSeller) {
    text = 'ショップを開設する';
  } else if (itemInCart.value) {
    text = 'カートに進む';
  }
  return text;
});
const onOK = () => {
  if (props.fromNative && isSp.value) {
    window.location.href = itemInCart.value ? urlForDeepLink(NativeView.CART) : urlForDeepLink(NativeView.WEBVIEW, { url: window.location.href });
  } else if (isPreSeller) {
    window.location.href = '/your/shop/setup';
  } else if (isSeller) {
    window.location.href = '/account';
  } else if (itemInCart.value) {
    window.location.href = '/cart';
  }
};
const onClose = () => {
  emit('close');
};
</script>

<style module lang="scss">
.content {
  font-size: 16px;
  text-align: center;
}

.icon {
  @media (--sp) {
    height: auto;
    width: 66px;
  }
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0;

  @media (--sp) {
    font-size: 18px;
  }
}

.lead {
  display: inline-block;
  font-size: 16px;
  margin: 0 0 15px;
  text-align: left;
}
</style>
